import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "gallery-block" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "My Gallery", -1)
const _hoisted_4 = { class: "gallery-items" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "gallery-block__grid" }
const _hoisted_7 = { class: "gallery-block__item-top" }
const _hoisted_8 = { class: "gallery-block__item-img" }
const _hoisted_9 = ["href"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "gallery-block__item-row" }
const _hoisted_12 = { class: "gallery-block__item-row" }
const _hoisted_13 = { class: "gallery-block__item-bottom" }
const _hoisted_14 = { class: "gallery-block__owner" }
const _hoisted_15 = { class: "gallery-block__owner-img" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "gallery-block__owner-name" }
const _hoisted_18 = { class: "gallery-block__owner-title" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "...", -1)
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  href: "mailto:{{ user?.email }}",
  class: "gallery-block__owner-link"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "gallery-block__item-crypto" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/ethereum.svg",
    alt: "#"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(($setup.nfts?.length || 0) !== 1 ? `${$setup.nfts?.length || 0} items` : `1 item`), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.nfts, (nft) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "gallery-block__item",
            key: nft.id
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("a", {
                  href: nft.permalink
                }, [
                  _createElementVNode("img", {
                    src: nft.img,
                    alt: "#"
                  }, null, 8, _hoisted_10)
                ], 8, _hoisted_9)
              ]),
              _createElementVNode("div", _hoisted_11, _toDisplayString(nft.name), 1),
              _createElementVNode("div", _hoisted_12, _toDisplayString(nft.description), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("img", {
                    src: $setup.user?.picture,
                    alt: "User's profile picture",
                    class: "rounded-circle nav-user-profile"
                  }, null, 8, _hoisted_16)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    (!$setup.user?.nickname?.includes('.eth'))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                          _createElementVNode("span", null, _toDisplayString($setup.user?.nickname?.slice(0, 5)), 1),
                          _hoisted_20,
                          _createElementVNode("span", null, _toDisplayString($setup.user?.nickname?.slice(-4)), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString($setup.user?.nickname), 1))
                  ]),
                  _createElementVNode("a", _hoisted_22, _toDisplayString($setup.user?.email), 1)
                ])
              ]),
              _hoisted_23
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}